.unitSelection {
  position: absolute;
  right: 10px;
  top: 1px;
  min-width: 30px;
  .ui__select__control {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }
}
